/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selector_Teams_Requires_PlanInputs */



/**
* | output |
* | --- |
* | "Teams are available from the Starter plan — only individual users can be picked on this plan." |
*
* @param {Selector_Teams_Requires_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selector_teams_requires_plan = /** @type {((inputs?: Selector_Teams_Requires_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selector_Teams_Requires_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teams sind ab dem Starter-Plan verfügbar — in diesem Plan können nur einzelne Benutzer ausgewählt werden.")
	return /** @type {LocalizedString} */ ("Teams are available from the Starter plan — only individual users can be picked on this plan.")
});